import React from "react";
import { Link } from "react-router-dom";

// Shown by the legacy publish and schedule controls when the server refuses a
// destination with POLICY_BLOCKED. Legacy features stay for unmanaged accounts.

export const isPolicyBlocked = (message: string | null | undefined): boolean => !!message && /POLICY_BLOCKED/.test(message);

export const POLICY_BLOCKED_TEXT = "This account is managed by the delivery pipeline. Use Delivery to send it to the owner.";

export const PolicyBlockedNotice: React.FC<{ error?: string | null }> = ({ error }) => {
  if (!isPolicyBlocked(error)) return null;
  return (
    <div
      role="alert"
      style={{
        fontFamily: "var(--font-sans)",
        fontSize: 12,
        lineHeight: 1.45,
        color: "var(--color-text)",
        background: "var(--color-warning-subtle)",
        border: "1px solid var(--color-warning)",
        borderRadius: 8,
        padding: "6px 10px",
        maxWidth: 360,
      }}
    >
      {POLICY_BLOCKED_TEXT} <Link to="/media-studio/pipeline">Open Delivery</Link>
    </div>
  );
};

export default PolicyBlockedNotice;
